export const PATIENT_WEB_PAGES_URLS = {
  auth: {
    login: 'auth/login',
    signup: 'auth/signup',
    resetPassword: 'auth/reset',
    verifyEmail: 'auth/verify'
  },
  account: {
    root: 'home',
    profile: 'profile',
    overview: 'overview',
    orders: 'orders',
    consultations: 'consultations',
    questionnaires: 'questionnaires',
    appointments: 'appointments',
    workshops: 'workshops',
    prescriptions: 'prescriptions',
    billing: 'billing'
  },
  subscriptions: {
    list: 'subscriptions',
    detail: 'subscriptions/:id'
  },
  orders: {
    detail: 'orders/:orderId'
  },
  checkout: 'checkout/:cartId', // used for v1 checkout
  checkouts: 'checkouts/:cartId', // used for v2 checkout
  questionnaires: {
    start: 'questionnaires/start'
  },
  consultations: {
    start: 'consultation/start',
    congratulation: 'thank-you',
    appointment: 'consultation/appointment'
  },
  verification: {
    start: 'verification/start',
  },
  appointments: {
    list: 'appointments',
    detail: 'appointments/:id',
    legacyDetail: 'appointment/:id'
  },
  labReq: {
    latest: 'lab-req-view/latest',
    detail: 'lab-req-view/:id'
  },
  prescriptions: {},
  messages: {
    inbox: 'messages',
    fileUpload: 'file-inbox/:id/:fileName'
  },
  digitalContent: {
    detail: 'digital-content/:id'
  },
  error: 'error'
};
Object.freeze(PATIENT_WEB_PAGES_URLS);
